import * as XLSX from "xlsx";
import {
  validateExcelFormat,
  formatDataFromExcel,
} from "../formatDataFromExcel";
import { showErrorMessage } from "../../usecases/commons/show-error-message";
import { translate as t } from "../../infrastructure/translate/localization";

export default function parseRowsFromExcel(type, file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onloadend = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "string", raw: true });
      const sheets = workbook.SheetNames.map((sheetName) => {
        const row = XLSX.utils.sheet_to_row_object_array(
          workbook.Sheets[sheetName]
        );
        return {
          data: row,
          sheetName,
        };
      });
      const parsedData = sheets?.[0]?.data
        .filter((item) => validateExcelFormat(type, item))
        .map((item) => formatDataFromExcel(type, item));

      if (parsedData.length === 0) {
        if (sheets?.[0].data.length > 0) {
          showErrorMessage(
            t("upload-employees-section.invalid-spreadsheet-upload-again"),
            true
          );
        } else {
          showErrorMessage(
            t("upload-employees-section.empty-file-upload-again"),
            true
          );
        }
      }
      resolve(parsedData);
    };
  });
}
